/* eslint-disable jsx-a11y/anchor-is-valid */
import Table from 'react-bootstrap/Table';
import React, {useState, useEffect, useRef} from 'react';
import {ContentHeader} from '@components';
import {read, utils, write} from 'xlsx';
import {Form} from 'react-bootstrap';
import {toast} from 'react-toastify';
import {Button} from 'react-bootstrap';
// import {Grid} from 'gridjs-react';
// import {_} from 'gridjs-react';
import Select from 'react-select';
import * as AuthService from '../services/auth';
import {PfButton} from '@profabric/react-components';
import Switch from 'react-bootstrap-switch';
import {logoutUser} from '@store/reducers/auth';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import {CSVLink} from 'react-csv';
import {useSelector} from 'react-redux';
import FileSaver from 'file-saver';

const TableItem = (props: any) => {
  const [data, setData] = useState<any>({loading: true});
  useEffect(() => {
    setData({...props.item});
    const fetchMyAPI = async (item: any) => {
      try {
        const checkSent = await AuthService.downloadSmslog(item.redemption_id);
        console.log(checkSent);
        if (item.step === 3 && item.result === '' && checkSent === null) {
          setTimeout(async () => {
            try {
              const response = await AuthService.sendVoucher(item);
              if (
                response.success === true &&
                response.mobile_no === item.phone.toString() &&
                response.redemption_id === item.redemption_id
              ) {
                let msg = '';
                if (item.token.country === 'CN')
                  msg = `${response.data1} / ${response.data2}`;
                else msg = response.url;
                setData((prevState) => ({
                  ...prevState,
                  loading: false,
                  result: `SUCCESS`,
                  voucher: msg
                }));
                props.onResult(item.index, false, `SUCCESS`, msg);
                AuthService.logMe(response);
              } else {
                setData((prevState) => ({
                  ...prevState,
                  loading: false,
                  result: 'FAIL',
                  voucher: ''
                }));
                props.onResult(item.index, false, 'FAIL', '');
                AuthService.logMe(response);
              }
            } catch {
              setData((prevState) => ({
                ...prevState,
                loading: false,
                result: 'FAIL',
                voucher: ''
              }));
              props.onResult(item.index, false, 'FAIL', '');
              AuthService.logMe({
                success: false,
                redemption_id: item.redemption_id,
                mobile_no: item.phone.toString(),
                remark: 'can not connect WS (1)'
              });
            }
          }, item.index * 2500);
        } else {
          setData((prevState) => ({
            ...prevState,
            loading: false,
            result: 'FAIL',
            voucher: ''
          }));
          props.onResult(item.index, false, 'FAIL', '');
        }
      } catch {
        setData((prevState) => ({
          ...prevState,
          loading: false,
          result: 'FAIL',
          voucher: ''
        }));
        props.onResult(item.index, false, 'FAIL', '');
        AuthService.logMe({
          success: false,
          redemption_id: item.redemption_id,
          mobile_no: item.phone.toString(),
          remark: 'can not connect WS (2)'
        });
      }
    };
    fetchMyAPI({...props.item});
  }, [props.item]);

  return (
    <tr>
      <td>{data.index}</td>
      <td>{data.name}</td>
      <td>{data.phone}</td>
      <td>
        <PfButton
          className="col-md-5"
          loading={data.loading}
          theme={
            data.loading === true
              ? 'secondary'
              : data.result === 'FAIL'
              ? 'danger'
              : 'success'
          }
          block
          type="button"
        >
          <i
            className={data.result === 'FAIL' ? 'fa fa-times' : 'fa fa-check'}
            aria-hidden="true"
          ></i>
        </PfButton>
      </td>
      <td className="d-none d-sm-table-cell">{data.result}</td>
    </tr>
  );
};
const Sms = () => {
  const user = useSelector((state: any) => state.auth.currentUser);
  const [campaign, setCampaign] = useState<any>('0000');
  const [confirm, setConfirm] = useState<any>(false);
  const [data, setData] = useState<any[]>([]);
  const [dataCopy, setDataCopy] = useState<any[]>([]);
  const [step, setStep] = useState<any>(1);
  const [hide, setHide] = useState('overlay dark');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const updateItem = (i: any, loa: any, res: any, vc: any) => {
    setDataCopy((prevState) => {
      return prevState.map((e) => {
        if (e.index === i)
          return {...e, result: res, loading: loa, voucher: vc};
        else return {...e};
      });
    });
  };

  useEffect(() => {
    const fetchInit = async () => {
      try {
        await downloadAllBatchWs();
        await downloadSuperAdminWs();
      } catch {}
    };

    fetchInit();
  }, []);

  const downloadSuperAdminWs = async () => {
    try {
      const admin = await AuthService.downloadSuperAdmin();
      if (admin.error) throw 'timeout';
      if (admin.find((e: any) => e.ADMIN_ID_EMP === user.ID_EMP))
        setHide('d-none');
      else setHide('overlay dark');
    } catch (error: any) {
      dispatch(logoutUser());
      navigate('/login');
    }
  };

  const downloadAllBatchWs = async () => {
    try {
      const dropdowns = await AuthService.downloadAllBatch();
      setDropdownBatch(dropdowns);
    } catch (error) {}
  };

  const downloadTokenWs = async (campaign: any) => {
    try {
      const _ftoken = await AuthService.downloadFToken(campaign);
      console.log(_ftoken);
      return _ftoken;
    } catch (error) {}
  };

  interface Contacts {
    name: string;
    phone: string;
  }

  const [dropdownBatch, setDropdownBatch] = useState([
    {
      value: '0000',
      label: 'Are you sure to send!!!'
    }
  ]);
  const fileUpload = async (e: any) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      let res1 = await validateFile(file);
      if (res1.length > 0) {
        setData(
          res1.map((e) => ({
            ...e,
            loading: true,
            phone: e.phone.toString().replace('+', '').replace(' ', '')
          }))
        );
        setDataCopy(
          res1.map((e) => ({
            ...e,
            loading: true,
            phone: e.phone.toString().replace('+', '').replace(' ', '')
          }))
        );
        setStep(2);
      } else {
        toast.error('Wrong file format!');
      }
    }
  };

  const downloadXlsx = (input: any, name: any) => {
    try {
      const ws = utils.json_to_sheet(input);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, 'Sheet1');
      const wbout = write(wb, {
        bookType: 'xlsx',
        bookSST: false,
        type: 'array'
      });
      FileSaver.saveAs(
        new Blob([wbout], {type: 'application/octet-stream'}),
        `${name}.xlsx`
      );
    } catch (err) {
      console.error('export error', err);
    }
  };

  const selectCampaign = async (v: any) => {
    try {
      if (v !== '0000') {
        console.log(v);
        setCampaign(v);
      } else {
        toast.error('Please select campaign!');
      }
    } catch {}
  };

  const handleSubmit = async () => {
    if (campaign !== '0000' && confirm === true) {
      try {
        const token = await downloadTokenWs(campaign);
        setStep(3);
        setData((prevState) => {
          return prevState.map((e) => ({
            ...e,
            loading: true,
            result: '',
            campaign: campaign,
            step: 3,
            token: token
          }));
        });
        setDataCopy((prevState) => {
          return prevState.map((e) => ({
            ...e,
            loading: true,
            result: '',
            campaign: campaign,
            step: 3,
            token: token
          }));
        });
      } catch (error) {}
    } else {
      if (campaign === '0000') toast.error('Please select campaign!');
      if (confirm === false) toast.error('Please confirm!');
    }
  };

  const validateFile = async (file: File) => {
    try {
      const data = await file.arrayBuffer();
      const workbook = read(data);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      let jsonData = utils.sheet_to_json<Contacts>(worksheet);
      console.log(jsonData);
      jsonData = jsonData.map((e, i) => ({
        ...e,
        index: i + 1,
        redemption_id: `${new Date()
          .toISOString()
          .split('.')[0]
          .replace(/[^\d]/gi, '')}-${i + 1}`
      }));
      if (
        !(
          jsonData[0].hasOwnProperty('name') &&
          jsonData[0].hasOwnProperty('phone') &&
          jsonData[0].hasOwnProperty('message')
        )
      ) {
        throw 'error';
      }
      return jsonData;
    } catch {
      return [];
    }
  };

  return (
    <div>
      <ContentHeader title="Manual sms" />
      <section className="content">
        <div className="container-fluid">
          <div
            className={step === 1 ? 'card card-primary' : 'card collapsed-card'}
          >
            {' '}
            <div className={hide}>
              <span style={{color: 'white', fontSize: 30}}>READ ONLY MODE</span>
            </div>
            <div className="card-header">
              <h3 className="card-title">Step 1 : Import excel</h3>
              <div className="card-tools">
                <button
                  onClick={() => {
                    window
                      .open(
                        'https://api-passport.advanceagro.net/file/SMS_TEMPLATE.xlsx',
                        '_blank'
                      )
                      ?.focus();
                  }}
                  type="button"
                  className="btn btn-tool"
                >
                  <i className="fa fa-file-csv" />
                </button>
              </div>
            </div>
            <div className={step === 1 ? 'card-body' : 'card-body d-none'}>
              <Form.Group className="mb-3 col-md-9">
                <Form.Control
                  type="file"
                  accept=".xlsx, .xls"
                  onChange={fileUpload}
                />
              </Form.Group>
            </div>
          </div>
          <div
            className={step === 2 ? 'card card-primary' : 'card collapsed-card'}
          >
            <div className="card-header">
              <h3 className="card-title">Step 2 : Validation</h3>
            </div>
            <div
              className={step === 2 ? 'card-body' : 'card-body d-none'}
              style={{
                height: '56vh',
                width: '100%',
                overflowY: 'scroll'
              }}
            >
              <Table striped>
                <thead>
                  <tr>
                    <th>Index</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Message</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((x, i) => (
                    <tr key={`v-${i}`}>
                      <td>{x.index}</td>
                      <td>{x.name}</td>
                      <td>{x.phone}</td>
                      <td>
                        <textarea
                          className="form-control"
                          style={{fontSize: 12}}
                          id="exampleFormControlTextarea1"
                          rows={2}
                          defaultValue={x.message}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {/* <Grid data={data} columns={['Index', 'Name', 'Phone']} /> */}
              <div className="row">
                <Form.Group className="col-md-4">
                  <Select
                    defaultValue={{
                      value: '0000',
                      label: 'Are you sure to send!!!'
                    }}
                    placeholder={'Select Campaign'}
                    options={dropdownBatch}
                    id="campaign"
                    onChange={(v) => selectCampaign(v?.value)}
                  />
                </Form.Group>
                <Form.Group>
                  <BootstrapSwitchButton
                    width={120}
                    checked={confirm}
                    onlabel="Confirm"
                    offlabel="No"
                    onChange={(checked: boolean) => {
                      setConfirm(checked);
                    }}
                  />
                  {/* <Switch
                    bsSize={'large'}
                    onText={'Confirm'}
                    offText={'-'}
                    onChange={(el, state) => setConfirm(state)}
                    value={confirm}
                  /> */}
                </Form.Group>
                <PfButton
                  className="col-md-2"
                  theme="success"
                  block
                  type="button"
                  onClick={handleSubmit}
                >
                  {'Send'}
                </PfButton>
              </div>
            </div>
          </div>
          <div
            className={step === 3 ? 'card card-primary' : 'card collapsed-card'}
          >
            <div className="card-header">
              <h3 className="card-title">Step 3 : Progression...</h3>
            </div>
            <div className={step === 3 ? 'card-body' : 'card-body d-none'}>
              <Table striped>
                <thead>
                  <tr>
                    <th>Index</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Status</th>
                    <th className="d-none d-sm-table-cell">Result</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((x, i) => (
                    <TableItem item={x} onResult={updateItem} key={`c-${i}`} />
                  ))}
                </tbody>
              </Table>
              <div className="row"></div>
            </div>
            <div className="card-footer">
              <CSVLink
                filename={'result'}
                className="btn btn-primary"
                data={dataCopy.map((e) => ({...e, token: ''}))}
              >
                CSV
              </CSVLink>
              <Button
                variant="success"
                className="ml-2"
                onClick={() => {
                  downloadXlsx(
                    dataCopy.map((e) => ({...e, token: ''})),
                    'result'
                  );
                }}
              >
                Excel
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Sms;
